<template>
    <div>
        <div class="row">
            <input-money v-if="empresaSelecionada.segmento != 'Distribuicao' && empresaSelecionada.segmento != 'Transmissao'" class="col-12 col-md-6" label="Baixa PEE" v-model="form.pee" ref="pee" />
            <input-money class="col-12 col-md-6" label="Baixa MEE" v-model="form.baixasMME" ref="mee" />
            <input-money class="col-12 col-md-6" label="Baixa FNDCT" v-model="form.baixasFNDCT" ref="fndct" />
            <input-money v-if="empresaSelecionada.segmento != 'Distribuicao' && empresaSelecionada.segmento != 'Transmissao'" class="col-12 col-md-6" label="Baixa CDE" v-model="form.baixasCDE" ref="cde" />
            <input-money v-if="empresaSelecionada.segmento == 'Distribuicao'" class="col-12 col-md-4" label="Baixa CDE PEE" v-model="form.baixasCDEPEE" ref="cde_pee" />
            <input-money v-if="empresaSelecionada.segmento == 'Distribuicao'" class="col-12 col-md-4" label="Baixa CDE P&D" v-model="form.baixasCDEPD" ref="cde_pd" />
            <input-money v-if="empresaSelecionada.segmento == 'Distribuicao'" class="col-12 col-md-4" label="Baixa PROCEL" v-model="form.baixasPROCEL" ref="procel" />
        </div>
    </div>
</template>
<script>
import InputMoney from "@/components/inputs/InputMoney";
import {FormMixin} from "@/common/mixins/FormMixin";
import {AlertasMixin} from "@/common/mixins/AlertasMixin";

export default {
    mixins: [FormMixin, AlertasMixin],
    components : {
        InputMoney
    },
    props : {
        form : {
            required : true,
        }
    },
    computed : {
        empresaSelecionada : function(){
            return this.$store.state.app.selectedCompanyObj;
        },
    }
}
</script>
<style>
</style>